import moment from "moment";
import { state as stateApp } from "../../../../app.logic";

export const formatInputValue = (str, format) => {
    let value = moment(str, format, true);
    if (!value.isValid()) {
        return str;
    }
    if (stateApp.locale === "th") {
        value = value.add(543, "years");
    }
    return value.format(format);
};

export const formatToMask = (format) => {
    return format.replace(/[A-Za-z]/g, "#");
};

export const formatToPlaceholder = (format) => {
    return format.toUpperCase();
};

export const onUpdateInputValue = ({ props, data, emit }) => {
    return (inputValue) => {
        data.inputValue = inputValue;
        const { format, valueFormat, valueFormat2 } = props;
        let inputValueStr = "";
        let value0ValueFormat = null;
        let value1ValueFormat = null;
        const value = data.inputValue.split(" - ");
        let value0 = moment(value[0], format, true);
        let value1 = moment(value[1], format, true);
        let canEmit = !inputValue;
        if (value0.isValid()) {
            if (stateApp.locale === "th") {
                value0 = value0.subtract(543, "years");
            }
            inputValueStr += value0.format(format);
            value0ValueFormat = value0.format(valueFormat);
            if (!value0.isSame(props.value?.[0]) || !value[1]) canEmit = true;
        }
        if (value0.isValid() && value1.isValid()) {
            if (stateApp.locale === "th") {
                value1 = value1.subtract(543, "years");
            }
            inputValueStr += value1.format(format);
            value1ValueFormat = value1.format(valueFormat2);
            if (!value1.isSame(props.value?.[1])) canEmit = true;
        }
        if (canEmit) {
            data.inputValue = inputValueStr;
            emit("update:value", [value0ValueFormat, value1ValueFormat]);
        }
    };
};

export const onBlurInputValue = ({ props, emit }) => {
    return () => {
        const value0 = props.value?.[0] || null;
        const value1 = props.value?.[1] || null;
        emit("update:value", [value0, value1]);
    };
};

export const onUpdateValue = ({ props, emit }) => {
    return (value) => {
        const value0 = value?.[0] || null;
        const value1 = value?.[1] || null;
        emit("update:value", [value0, value1 ? moment(value1).format(props.valueFormat2) : null]);
    };
};

export const createOnChange = ({ props, data }) => {
    return () => {
        if (!props.showTime) {
            data.open = false;
        }
    };
};

export const createOnOpenChange = ({ data }) => {
    return (open) => {
        data.mode = "date";
        data.open = open;
    };
};

export const createOnPanelChange = ({ data }) => {
    return (value, mode) => {
        data.mode = mode;
    };
};
